/** 显式传参的平滑滚动不受 CSS scroll-behavior 覆盖,必须在 JS 侧尊重系统减动效设置。 */
export function prefersReducedMotion(): boolean {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function smoothScrollBehavior(): ScrollBehavior {
  return prefersReducedMotion() ? "auto" : "smooth";
}
